import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../../css/VideoInfoCard.css';
import { Video } from '../../../interfaces/userInterfaces';
import { dateConverter } from '../../../services/formatDate.js';
import { useUser } from '../../../hooks/useUser';

export const VideoInfoCard = (videoInfo: Video) => {
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const { user } = useUser();

  const redirectRoute = () =>
    user?.username === videoInfo.username ? '/profile' : `../profile/${videoInfo.id}`;

  const defaultAvatar =
    'https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/avatars/default-avatar/userexpression.png';

  return (
    <section className="video-details">
      {/* Uploader row */}
      <span className="user-info">
        <Link to={redirectRoute()}>
          <img
            className="user-video-avatar"
            src={videoInfo?.profile?.avatar_url ?? defaultAvatar}
            alt={videoInfo?.username}
          />
        </Link>
        <Link to={redirectRoute()} className="user-video-username">
          {videoInfo?.username}
        </Link>
      </span>

      {/* Title */}
      <p className="video-description-title">{videoInfo?.title}</p>

      {/* Expandable description */}
      <details
        onClick={() => setDescriptionOpen((o) => !o)}
        className={
          descriptionOpen
            ? 'video-description-details-paragraph-open'
            : 'video-description-details-paragraph-closed'
        }
      >
        <summary>Description</summary>
        <p style={{ marginTop: 8 }}>{videoInfo?.description ?? 'No description.'}</p>
      </details>

      {/* Meta row */}
      <div className="video-meta-row">
        <span className="video-description-uploaded">
          Uploaded {dateConverter(videoInfo?.created_at)}
        </span>
        <span className="view-count">{videoInfo?.views?.toLocaleString()} views</span>
      </div>
    </section>
  );
};
